<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card
        [cardOptionBtnValue]="'global.add_btn_text'|translate "
        [cardOptionBtnIcon]="'feather icon-plus'"
        [cardOptionBtn]="false"
        [title]="'global.overview'|translate"
      >
        <app-grid [grid]="grid"></app-grid>
      </app-card>
    </div>
  </div>
</div>

<ng-template #cellEllipsisTooltip let-row="row" let-value="value" let-column="column">
  <ng-container *ngIf="cellDisplay(column, value) as cell">
    <span
      class="exchange-log-cell-ellipsis"
      [ngbTooltip]="cell.text"
      [disableTooltip]="!cell.showTooltip"
      placement="top"
      container="body"
      [tooltipClass]="column?.prop === 'message' ? 'exchange-log-message-tooltip' : 'exchange-log-cell-tooltip'"
    >
      {{ cell.text }}
    </span>
  </ng-container>
</ng-template>


<ng-template #exchangeLogRowDetail let-row="row">
  <div class="exchange-log-row-detail">
    <div><strong>{{ 'doctrine.exchange_log.newValue' | translate }}:</strong> {{ detailText(row?.newValue) }}</div>
    <div><strong>{{ 'doctrine.exchange_log.oldValue' | translate }}:</strong> {{ detailText(row?.oldValue) }}</div>
    <div><strong>{{ 'doctrine.exchange_log.changedBy' | translate }}:</strong> {{ detailText(row?.changedBy?.fullName) }}</div>
    <div><strong>{{ 'doctrine.exchange_log.message' | translate }}:</strong> {{ detailText(row?.message) }}</div>
  </div>
</ng-template>
